


















































































import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";
import { IState } from "@/store";
import { mapState } from "vuex";
import HasValidation from "@/mixins/HasValidation";
import { DataModules } from "@/store/modules/data";
import { IAffiliateLink } from "@/models/affiliate";
import RequestPromises from "@/mixins/requestPromises";
import { Component, Mixins, Prop, Inject } from "vue-property-decorator";
import { BrandConfigKeys } from "@/data/constants";
import Context from "@/mixins/context";
import { CreateElement, RenderContext } from "vue";

@Component({
  computed: {
    ...mapState({
      affiliateLinkScope(state: IState, getters) {
        return getters[`data/${DataModules.AFFILIATES_LINKS}/scope`]({
          accountId: this.affiliateData.accountId,
          affiliateLinkId: this.affiliateLinkId
        });
      },
      affiliateLink(state: IState, getters) {
        return (
          getters[`data/single`]({
            storeModule: DataModules.AFFILIATES_LINKS,
            scope: this.affiliateLinkScope
          }) || {}
        );
      }
    })
  }
})
export default class AddEditAffiliateLinkModal extends Mixins(
  Context,
  HasValidation,
  RequestPromises
) {
  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  // Props
  @Prop({ required: true })
  public affiliateLinkId!: IAffiliateLink["id"];

  // Data
  public affiliateLink!: IAffiliateLink;
  public affiliateLinkScope!: string;
  public affiliateLinkIsLoading = true;
  public affiliateLinkIsReloading = false;
  public affiliateLinkIsProcessing = false;
  public affiliateLinkHasRequestError = false;
  public dataModule = DataModules.AFFILIATES_LINKS;
  public form = {
    name: "",
    redirect_url:
      this.$store.getters["brand/config"][
        BrandConfigKeys.AFFILIATES_DEFAULT_REDIRECT_LINK
      ] || ""
  } as IAffiliateLink;

  // Getters
  public get affiliateData() {
    return this.$affiliateData();
  }

  public get isEdit() {
    return !!this.affiliateLinkId;
  }

  public get hasChange() {
    return !this.$_.isEqual(
      this.form,
      this.$_.pick(this.affiliateLink, Object.keys(this.form))
    );
  }

  public get isFormDisabled() {
    return (
      !(this.isEdit
        ? this.affiliateData.canUpdateLink
        : this.affiliateData.canCreateLink) ||
      this.affiliateLinkIsProcessing ||
      this.hasErrors ||
      !this.hasChange
    );
  }

  public get brandDomain() {
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) =>
        this.isAdmin
          ? h(
              "u-link",
              {
                props: { to: { name: "brandDomainsSettings" } },
                on: {
                  click: () => this.$emit("close")
                }
              },
              children
            )
          : children
    };
  }

  // Lifecycle methods
  public created() {
    this.loadInitialData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: this.dataModule,
      scope: this.affiliateLinkScope,
      vm: this
    });
  }

  // Methods
  public async loadInitialData(ignoreStored = false) {
    try {
      this.affiliateLinkIsLoading = true;
      if (this.isEdit) {
        await this.$affiliateMethods.getAffiliateLink({
          vm: this,
          id: this.affiliateLinkId,
          accountId: this.affiliateData.accountId,
          scope: this.affiliateLinkScope,
          ignoreStored
        });
        this.setForm();
      }
      this.affiliateLinkHasRequestError = false;
    } catch (error) {
      const is404 = this.$store.getters["api/is404"](error);
      if (is404) return;
      this.affiliateLinkHasRequestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.affiliateLinkIsLoading = false;
    }
  }

  public setForm() {
    this.form.name = this.affiliateLink.name;
    this.form.redirect_url = this.affiliateLink.redirect_url;
  }

  public async reloadInitialData() {
    this.affiliateLinkIsReloading = true;
    await this.loadInitialData(true);
    this.affiliateLinkIsReloading = false;
  }

  public save() {
    return this.isEdit
      ? this.$affiliateMethods.updateAffiliateLink({
          vm: this,
          id: this.affiliateLinkId,
          accountId: this.affiliateData.accountId,
          data: this.form,
          scope: this.affiliateLinkScope
        })
      : this.$affiliateMethods.createAffiliateLink({
          vm: this,
          accountId: this.affiliateData.accountId,
          data: this.form,
          scope: this.affiliateLinkScope
        });
  }

  public async validateBeforeSubmit() {
    try {
      this.affiliateLinkIsProcessing = true;
      const result = await this.validate();
      if (!result) throw this.$t("_sentence.form_is_not_valid");

      await this.save();
      this.$emit("close");
      this.$emit("success");
      this.$buefy.toast.open({
        message: this.$t("_sentence.successfully_saved") as string
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.affiliateLinkIsProcessing = false;
    }
  }
}
